<template>
  <div
    class="categories-page"
    data-test="category-container">
    <div
      class="container category-container">
      <loader
        v-show="!data_loaded"
        :center="true"
        label="Fetching Data..."
      />
      <h2 class="title"> All Categories </h2>
      <el-row
        :gutter="16"
        class="category-card-container"
        data-test="list-category"
      >
        <el-col
          v-check-visible-viewport="onVisibleInViewport"
          v-for="(item, index) in categories"
          :key="index"
          :xs="{span:12}"
          :sm="{span:6}"
          :md="{span:6}"
          :lg="{span:4}"
          :xl="{span:4}"
          :data-segment-uuid="item.uuid"
          class="category-card"
          data-test="category-card">
          <router-link
            :to="(!item.slug || !item.uuid) ? '/exclusives' : `/listen/category/${item.slug}/${item.uuid}`">
            <img
              :src="item.image_uri"
              :alt="item.name"
              :placeholder="placeholder"
            >
          </router-link>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import * as log from 'loglevel';
import PodcastCard from '../components/PodcastCard';
import Podcast from '../services/Podcast';
import Loader from '../components/Loader';
import placeholder from '../assets/images/placeholder.png';
import ScrollMixin from '../shared/scrollMixin';
import PageMixin from '../shared/pageMixin';
import LuminaryExclusives from '../assets/images/exclusives.png';

export default {
  name: 'Categories',
  components: {
    'podcast-card': PodcastCard,
    loader: Loader,
  },
  mixins: [ScrollMixin, PageMixin],
  data() {
    return {
      pageName: 'All Categories',
      list: null,
      category_service: new Podcast(),
      categories: [],
      data_loaded: false,
      placeholder,
      bucket: {
        uuid: null,
        name: 'All Categories',
        bucket_type: 'categories',
        media_size: 'thumbnail',
      },
      LuminaryExclusives,
    };
  },
  beforeMount() {
    this.loadCategories();
    this.parentSelector = 'categories-page';
    this.childSelector = '.categories-page .category-card.is-visible';

    this.setMetaInformation('Browse Podcast Categories | Luminary', 'Browse podcasts by categories. With 500k+ shows to choose from, Luminary is the best place to discover and listen to podcasts, when and where you want.');
  },
  destroyed() {
    this.setMetaInformation();
  },
  methods: {
    loadCategories() {
      this.category_service.loadCategories().then((resp) => {
        if (!resp) return;
        this.categories = resp || [];
        this.categories.unshift({ name: 'Luminary Exclusives', image_uri: LuminaryExclusives });
        this.contentList = this.categories;
        this.data_loaded = true;
      }).catch((err) => {
        log.info(err);
        this.data_loaded = true;
      });
    },
    navigateToCategories(category) {
      if (!category.slug || !category.uuid) {
        this.$router.push('/exclusives');
        return;
      }
      this.eventProvider.triggerContentSelectEvent(this.bucket, category);
      this.$router.push(`/listen/category/${category.slug}/${category.uuid}`);
    },
    onVisibleInViewport(uuid) {
      const ele = document.querySelector(`[data-segment-uuid="${uuid}"]`);
      if (ele) {
        ele.classList.add('is-visible');
      }
    },
  },
};
</script>
<style lang="scss">
@import "../assets/scss/variables.scss";
.categories-page {
  .category-container {
    .title {
      font-size: 32px;
      line-height: 36px;
      margin: 40px 0 !important;
    }
    .category-card-container {
      .category-card {
        margin: 0 0 14px 0;
        display: inline-block;
        box-sizing: border-box;
        img {
          width: 100%;
          height: 100%;
          min-height: 129px;
          background: $xxlight-gray;
          object-fit: cover;
          border-radius: 3px;
          transition: .3s all ease-in-out;
          cursor: pointer;
          box-shadow: 0px 0px 2px 2px rgba(17,17,17,.1);
          &:hover {
            box-shadow: 0px 0px 4px 4px rgba(17,17,17,.1);
          }
        }
      }
    }
  }
}
@media (max-width: 1024px) {
  .categories-page {
    .category-container {
      .category-card-container {
        .category-card {
          img {
            min-height: 139px;
          }
        }
      }
    }
  }
}
@media (max-width: 768px) {
  .categories-page {
    .category-container {
      .category-card-container {
        .category-card {
          img {
            min-height: 103px;
          }
        }
      }
    }
  }
}
@media (max-width: 576px) {
  .categories-page {
    .category-container {
      .category-card-container {
        .category-card {
          img {
            min-height: 95px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// app/src/pages/Categories.vue